import permission from './permission'

const install = function(Vue) {
  Vue.directive('permission', permission)
  Vue.directive('auditManager', permission)
  Vue.directive('transDownload', permission)
  Vue.directive('disbursementCheck', permission)
  Vue.directive('disbursementConfirm', permission)
  Vue.directive('disbursementApprove', permission)
  Vue.directive('recharge', permission)
  Vue.directive('withdraw', permission)
  Vue.directive('transfer', permission)
  Vue.directive('trans-details', permission)
}

if (window.Vue) {
  window['permission'] = permission
  window['auditManager'] = permission
  window['transDownload'] = permission
  window['disbursementCheck'] = permission
  window['disbursementConfirm'] = permission
  window['disbursementApprove'] = permission
  window['recharge'] = permission
  window['withdraw'] = permission
  window['transfer'] = permission
  window['trans-details'] = permission
  Vue.use(install); // eslint-disable-line
}

permission.install = install
export default permission
